import axios from "axios";
import { LOGIN_ } from "../../constant/API constant";

export const Login = (email, password) => {
  return axios.post(`${process.env.REACT_APP_API_URL}${LOGIN_}`, {
    email,
    password,
  });
};
